import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { KieneTableService } from '../../../../../../../../src/app/components/kiene-table/kiene-table.service';
import { API_BASE_URL_SERVICE } from '../../../../kiene-core.config';
import { AppService } from '../../../../services/app/app.service';
import { Client } from '../../../client/classes/client';
import { BetriebAuswaehlenDialogComponent } from '../../../dialogs/betrieb-auswaehlen-dialog/betrieb-auswaehlen-dialog.component';
import { Gruppe } from '../../classes/gruppe';
import {
    buildGruppeAuswaehlenDialogConfig,
    GruppeAuswaehlenDialogInput,
    GruppeAuswaehlenDialogResult,
} from '../../gruppe-auswaehlen-dialog/gruppe-auswaehlen-dialog';
import { GruppeAuswaehlenDialogComponent } from '../../gruppe-auswaehlen-dialog/gruppe-auswaehlen-dialog.component';
import { GruppeSchweinDialogInput } from '../gruppe-schweine-dialog/gruppe-schweine-dialog';
import { GruppeSchweineDialogComponent } from '../gruppe-schweine-dialog/gruppe-schweine-dialog.component';
import { GruppeBewegung } from '../tod-melden-dialog/tod-melden-dialog';
import { UmstallenGruppeFrageDialogResult } from '../umstallen-gruppe-frage-dialog/umstallen-gruppe-frage-dialog';
import { UmstallenGruppeFrageDialogComponent } from '../umstallen-gruppe-frage-dialog/umstallen-gruppe-frage-dialog.component';
import { StammdatenService } from '../../../stammdaten/stammdaten.service';
import { MessageService } from '../../../../services/message-service/message.service';

@Component({
    selector: 'kiene-umstallen-dialog',
    templateUrl: './umstallen-dialog.component.html',
    styleUrls: ['./umstallen-dialog.component.scss'],
})
export class UmstallenDialogComponent implements OnInit {
    umstalldatumCtrl: FormControl = new FormControl(undefined, [Validators.required]);
    ausstallgewichtProTierCtrl: FormControl = new FormControl();
    futtermengeProTierCtrl: FormControl = new FormControl();
    futtermengeGesamtCtrl = new FormControl();
    anzahlTiereCtrl: FormControl = new FormControl(undefined, [Validators.required, Validators.min(1)]);

    isSaving = false;
    isMobile = false;
    mehrereVvvos = false;

    constructor(
        public dialogRef: MatDialogRef<UmstallenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) protected gruppe: Gruppe,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
        private readonly messageService: MessageService,
        private readonly matDialog: MatDialog,
        private readonly api: KieneTableService,
        private readonly appService: AppService,
        private readonly stammdatenService: StammdatenService,
    ) {}

    ngOnInit(): void {
        this.isMobile = this.appService.isMobileScreen;
        if (this.gruppe?.anzahl_tiere_gesamt) {
            this.anzahlTiereCtrl.setValue(this.gruppe.anzahl_tiere_aktuell);
        }

        this.futtermengeProTierCtrl.valueChanges.subscribe({
            next: value => {
                if (value && this.anzahlTiereCtrl.value) {
                    const gew = Math.round(value * this.anzahlTiereCtrl.value * 100) / 100;
                    this.futtermengeGesamtCtrl.setValue(gew, { emitEvent: false });
                }
            },
        });

        this.futtermengeGesamtCtrl.valueChanges.subscribe({
            next: value => {
                if (value && this.anzahlTiereCtrl.value > 0) {
                    const gew = Math.round((value / this.anzahlTiereCtrl.value) * 100) / 100;
                    this.futtermengeProTierCtrl.setValue(gew, { emitEvent: false });
                }
            },
        });

        this.anzahlTiereCtrl.valueChanges.subscribe({
            next: value => {
                if (value) {
                    if (this.futtermengeProTierCtrl.value > 0) {
                        const futter = Math.round(value * this.futtermengeProTierCtrl.value * 100) / 100;
                        this.futtermengeGesamtCtrl.setValue(futter, { emitEvent: false });
                    }
                }
            },
        });

        this.stammdatenService.ladeVvvos().subscribe({
            next: result => {
                this.mehrereVvvos = result?.count > 1;
            },
            error: err => {
                this.messageService.errorMessage('Fehler beim Laden der VVVOs!', err);
            },
        });
    }

    public save(zielgruppe: Gruppe, neueGruppe: boolean): void {
        this.isSaving = true;
        const bewegung = new GruppeBewegung();
        bewegung.gruppe_id = this.gruppe?.gruppe_id;
        bewegung.anzahl_tiere = this.anzahlTiereCtrl.value;
        bewegung.datum = this.umstalldatumCtrl.value;
        bewegung.ausstallgewicht = this.ausstallgewichtProTierCtrl.value;
        bewegung.futtermenge = this.futtermengeProTierCtrl.value;
        bewegung.bewegung_typ = 6;
        bewegung.gruppe_id_ziel = zielgruppe?.gruppe_id;
        bewegung.einstallen_buchen = neueGruppe ? 0 : 1;
        bewegung.an_hit_melden = 0;

        this.api.post(this.apiBaseUrl + 'gruppe_bewegung/update.php', bewegung).subscribe({
            next: () => {
                this.dialogRef.close(true);
            },
            error: error => {
                this.isSaving = false;
                this.messageService.errorMessage('Gruppe konnte nicht umgestallt werden!', error);
            },
        });
    }

    addZielgruppe(kunde_id: number, betriebsart_id: number) {
        const grp = new Gruppe();
        grp.einstalldatum_von = this.umstalldatumCtrl.value;
        grp.einstall_gewicht = this.ausstallgewichtProTierCtrl.value;
        grp.anzahl_tiere = this.anzahlTiereCtrl.value;
        grp.zugang_melden = 0;
        const input = new GruppeSchweinDialogInput(kunde_id, betriebsart_id, {
            gruppe: grp,
            showAnzahlDatumGewicht: false,
        });
        this.matDialog
            .open<GruppeSchweineDialogComponent, GruppeSchweinDialogInput, Gruppe>(GruppeSchweineDialogComponent, {
                data: input,
            })
            .afterClosed()
            .subscribe({
                next: (gruppe: Gruppe) => {
                    if (gruppe) {
                        this.save(gruppe, true);
                    }
                },
            });
    }

    public selectZielgruppe(kunde_id: number, except_gruppe_id: number) {
        const input = new GruppeAuswaehlenDialogInput();
        input.except_gruppe_id = except_gruppe_id;
        input.kunde_id = kunde_id;
        this.matDialog
            .open(
                GruppeAuswaehlenDialogComponent,
                buildGruppeAuswaehlenDialogConfig(input, { mobile: this.isMobile }),
            )
            .afterClosed()
            .subscribe({
                next: (result: GruppeAuswaehlenDialogResult) => {
                    if (result?.gruppe) {
                        this.save(result.gruppe, false);
                    }
                },
            });
    }

    public isDisabled(): boolean {
        return this.anzahlTiereCtrl.invalid || this.umstalldatumCtrl.invalid || this.isSaving;
    }

    umstallenEigeneVvvo() {
        this.umstallen(this.gruppe?.kunde_id, this.gruppe?.betriebsart_id);
    }

    umstallenAndereVvvo() {
        const inhaberKundeId = Number(this.gruppe?.kunde_id) || null;
        this.matDialog
            .open(BetriebAuswaehlenDialogComponent, {
                position: { top: '10px' },
                data: { inhaberKundeId, mitFreigegebenenBetrieben: true },
            })
            .afterClosed()
            .subscribe({
                next: (client: Client) => {
                    if (client) {
                        this.umstallen(client.kunde_id, client.betriebsart_id);
                    }
                },
            });
    }

    public umstallen(kunde_id: number, betriebsart_id: number): void {
        this.matDialog
            .open(UmstallenGruppeFrageDialogComponent, { maxWidth: '600px', width: '100%' })
            .afterClosed()
            .subscribe({
                next: (result: UmstallenGruppeFrageDialogResult) => {
                    if (result?.confirmed) {
                        if (result.result === 'neu') {
                            this.addZielgruppe(kunde_id, betriebsart_id);
                        } else if (result.result === 'auswahl') {
                            this.selectZielgruppe(kunde_id, this.gruppe?.gruppe_id);
                        }
                    }
                },
            });
    }
}
